import { NICmsContentComponent } from '@icms/core/content';

export namespace NCmsComponentRowAccordion {
    export const ID = 'row-accordion';

    export interface IData extends NICmsContentComponent.IData {
        // below this size id we make it accordion
        accordionBreakdown: number;
        columns: IAccordionColumn[];
    }

    export interface IAccordionColumn {
        // number of columns
        size: number;
        // heading
        heading: string;
        components: NICmsContentComponent.IData[];
    }
}
